module.exports = __webpack_public_path__ + "img/logo_v5.ae22aaf1.png";